<fab-loading-spinner *ngIf="isPageLoading"></fab-loading-spinner>
<mat-dialog-content>
    <div class="modal-container">
        <h1 class="header">Create New Public Holiday</h1>
        <form fxLayout="column" fxLayoutAlign="center" #form="ngForm">
            <table>
                <tr>
                    <th id="fixed-header">Fixed:</th>
                    <td>
                        <mat-checkbox id="fixed" name="fixed" [(ngModel)]="isBool"></mat-checkbox>
                    </td>
                </tr>
                <tr>
                    <th id="half-day">Half Day:</th>
                    <td class="inline-block padding">
                        <mat-checkbox id="halfDay" name="halfDay" [(ngModel)]="publicHoliday.halfDay"></mat-checkbox>
                    </td>
                </tr>
                <tr>
                    <th id="shutdown-day">Shutdown Day:</th>
                    <td class="inline-block padding">
                        <mat-checkbox id="shutdownDay" name="shutdownDay" [(ngModel)]="publicHoliday.shutdownDay"></mat-checkbox>
                    </td>
                </tr>
                <tr>
                    <th id="holiday">Holiday Name:</th>
                    <td>
                        <mat-form-field appearance="outline">
                            <input matInput id="holidayName" [(ngModel)]="publicHoliday.holidayName" name="holidayName"
                                   required/>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <th id="hol-date">Holiday Date:</th>
                    <td>
                        <mat-form-field class="filterSize" appearance="outline">
                            <mat-label>Enter date</mat-label>
                            <input matInput [matDatepicker]="picker" [formControl]="date" required readonly>
                            <mat-hint fxLayoutAlign="center">DD/MM/YYYY</mat-hint>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                    </td>
                </tr>

                <div fxLayoutAlign="space-between center" fxLayout="row wrap" class="align-self-center mx-auto">
                    <button class="buttons mycentered-text" mat-raised-button color="primary" type="button" (click)="close()">
                        Cancel
                    </button>
                    <br/>
                    <button class="mycentered-text" mat-raised-button color="primary" [disabled]="!form.form.valid"
                            (click)="submitHoliday(isBool)">Approve
                    </button>
                </div>
            </table>
        </form>
    </div>
</mat-dialog-content>
